/*
RajeshK  09/19/2022  2698403926  Fixed GAL (136,137,158,98) and field group table GAL-153
Sohel    09/21/2022  2698403926  Fixed Client Maintainance Bugs
Ashraf   10/10/2022  2698403926  fixed tooltip for current rate popup in client maintenance, redirect when access is not given
Ashraf   10/10/2022  2698403926  Fixed role based access, client maintenance edit rate popup issues
Suresh Peddavoora 10/30/2022 2698403926  Added Class Name for Button Enhancements
dilip 11/01/2022 2698403926 Removed advance search button
Ashraf 11/14/2022 2698403926 moved search form into div
*/
import React, {useState, useContext, useEffect} from 'react';
import {useSelector} from 'react-redux';
import SearchDashboardTable from './SearchDashboardTable';
import {ErrorSnackbar} from '../../../components/CustomSnackBar';
import {useHistory} from 'react-router';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useDispatch} from 'react-redux';
import {fetchClientData} from '../../../redux/reducers/ClientDashboard';

export default function SearchOverview({data}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchedData, setSearchedData] = useState(false);
  const [searchResults, setSearchResults] = useState(0);
  const {errorMsg} = useSelector(({dashboardClient}) => dashboardClient);
  const {roleData} = useSelector(({role}) => role);
  const [search, setSearch] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [clear, setClear] = useState(false);
  const [advancedSearchData, setAdvancedSearchData] = useState('');
  const history = useHistory();
  const handleSearch = () => {
    setSearch(!search);
  };

  const dispatch = useDispatch();

  const vals = {
    parentClientName: '',
    clientName: '',
    searchBy: '',
    searchTerm: '',
    clientPrefix: '',
  };

  useEffect(() => {
    dispatch(fetchClientData(vals));
  }, []);

  useEffect(() => {
    if (roleData &&
       Object.keys(roleData) &&
       roleData?.window &&
       !roleData?.window?.['Client Maintenance']?.CG?.read) {
      history.replace('/account-summary');
    }
  }, [roleData]);

  return (
    <>
      <div className="global-field-dash-board">
        <div className={`${classes.cardBordernoneStyles} rounded `}>
          {/* <div className="col-md-12  text-right mb-2">
          <Button
            variant="outlined"
            size="large"
            className={`mx-1  search-btn ${classes.buttonRoot}`}
            onClick={() => history.push("/parent-client")}
            disabled={!roleData?.window?.["Client Maintenance"]?.PC?.read}
          >
            Parent Client
          </Button>
          <Button
            variant="outlined"
            size="large"
            className={`mx-1  search-btn ${classes.buttonRoot}`}
            onClick={() => history.push("/client-form")}
            disabled={!disabledByRole?.AC?.add}
          >
            <AddIcon />
            Add Client
          </Button>
          <Button
            variant="outlined"
            size="large"
            className={`mx-1  settings-button ${classes.buttonRoot}`}
            onClick={() => handleSearch()}
          >
            {!search ? "Advanced Search" : "Cancel"}
          </Button>
        </div> */}

          {searchedData?.length === 1 &&
        history.push({
          pathname: `/client-maintenance`,
          state: {
            clientNumber: searchedData[0]?.clientNumber ? searchedData[0].clientNumber : '',
          },
        })}
          <SearchDashboardTable
            searchedData={searchedData}
            handleSearch={handleSearch}
            searchResults={searchResults}
            setSearchedData={setSearchedData}
            setSearchResults={setSearchResults}
            submit={submit}
            advancedSearchData={advancedSearchData}
            setAdvancedSearchData={setAdvancedSearchData}
            clear={clear}
            setClear={setClear}
            setSubmit={setSubmit}
            search={search}
          />
          {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        </div>
      </div>
    </>
  );
}
